// 触发保存菜单栏的路径方法
export const savePaths = ({ commit }, payload) => {
    commit('savePaths', payload);
};



// WEBPACK FOOTER //
// ./src/store/actions.js